<template>
  <div class="popup-button display-middle" @click="$emit('click')" :class="{ 'button-default' : buttonType === 'default', 'button-ok' : buttonType === 'ok' }">
    <span class="position-center fsdfds-button">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    buttonType: {
      type: String,
      default: () => 'default'
    }
  }
}
</script>

<style lang="stylus" scoped>
  .popup-button {
    background-color: #F5F7FA;
    position: relative;
    transition: all .2s;
    font-size: 17px;
    font-family: Helvetica Neue;
    font-weight: bold;
    text-transform: capitalize;
  }
  .popup-button:active {
    opacity: .3;
  }
  .button-default {
    color: #5D667F;
  }
  .button-ok {
    color: #FC821A;
  }
  .fsdfds-button {
    width: 100%;
    text-align center
  }
</style>